import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { InvestmentsService } from 'src/app/_services/investments.service';
import { LoansService } from 'src/app/_services/loans.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { StorageService } from 'src/app/_services/storage.service';

@Component({
  selector: 'app-recenttransactions',
  templateUrl: './recenttransactions.component.html',
  styleUrls: ['./recenttransactions.component.css']
})
export class RecenttransactionsComponent implements OnInit {

  @Input('mini') mini = false;
  user:any;
  data:any;
  constructor(private storageService: StorageService, private invService: ProfileService, private authService: AuthenticationService) { 
    this.user = this.storageService.read<any>('user');
  }

  ngOnInit() {
    this.getUserBanks();
  }
  getUserBanks() {

    //this.loading = true; 
    this.invService.getRecentTransactions({token: this.user.token,'mini': this.mini})
      .subscribe(result => {
         this.data = result.recent_transactions;
      }, err => { 
      });
  }
}